module.exports = __webpack_public_path__ + "img/logo.238e1728.png";